import * as React from "react";

import { assertNever } from "@impero-com/common/utils/obj";

import {
    Quarter,
    SchedulingOccurrenceChangeForDueDateOffsetForMonthOffsetPeriod as SchedulingOccurrenceChange,
} from "api/generated/model";
import { translateQuarter } from "org/control/list/utils";

import { GenericCustomDueDatesModal } from "../common/genericCustomDueDatesDialog";
import { GenericOccurrencesArray } from "../common/rulesWithArrays";
import { CustomDueDatesTypedProps } from "../types";

const ALL_OCCURRENCES: Quarter[] = ["First", "Second", "Third", "Fourth"];

type QuarterlyCustomDueDatesModalProps = CustomDueDatesTypedProps<Quarter> & {
    initialCurrentOccurrences: GenericOccurrencesArray<Quarter>;
};

class QuarterlyCustomDueDatesModal extends React.Component<QuarterlyCustomDueDatesModalProps> {
    onChange = (
        currentOccurrences: Partial<Record<Quarter, SchedulingOccurrenceChange>>
    ) => {
        if (this.props.type !== "EDIT") {
            throw new Error("not editable");
        }
        const { onChange } = this.props;
        ALL_OCCURRENCES.forEach((occurrence) => {
            const change = currentOccurrences[occurrence];
            if (change !== undefined) {
                onChange(occurrence, change);
            }
        });
    };

    render = () => {
        const { type, initialCurrentOccurrences } = this.props;

        let typedProps;
        switch (type) {
            case "EDIT": {
                typedProps = {
                    type: "EDIT" as const,
                    onChange: this.onChange,
                };
                break;
            }
            case "READ_ONLY": {
                typedProps = {
                    type: "READ_ONLY" as const,
                };
                break;
            }
            default: {
                return assertNever(type);
            }
        }

        return (
            <GenericCustomDueDatesModal<Quarter>
                {...typedProps}
                initialCurrentOccurrences={initialCurrentOccurrences}
                allOccurrences={ALL_OCCURRENCES}
                translateOccurrence={translateQuarter}
                translateOccurrenceShort={translateQuarter}
                interval={"Quarter"}
            />
        );
    };
}

export { QuarterlyCustomDueDatesModal };
